import React from "react";
import {
    AppLayout,
    Header,
    SideNavigation,
    Container,
    ContentLayout,
    ColumnLayout,
    Cards,
    Box,
    Link,
    Image,
    SpaceBetween,
    Button,
} from '@cloudscape-design/components';
import {BreadcrumbGroup} from '@cloudscape-design/components';
import Trisha from '../images/hyperbadge_jaggit.png'
import McKinnon from '../images/hyperbadge_mckinnrr.png'
import Prudhvi from '../images/hyperbadge_prudpotl.png'
import Varsha from '../images/hyperbadge_palepvar.png'

import { NavigationSide } from "./Navigation";
const teamMembers = [
    {
      name: "McKinnon Robinson",
      role: "Solution Architect",
      contact: "mckinrr@amazon.com",
      photoUrl: McKinnon,
    },
    {
      name: "Trisha Jaggi",
      role: "Solution Architect",
      contact: "jaggit@amazon.com",
      photoUrl: Trisha,
    },
    {
      name: "Prudhvi Potluri",
      role: "Solution Architect",
      contact: "prudpotl@amazon.com",
      photoUrl: Prudhvi,
    },
    {
      name: "Varsha Palepu",
      role: "Solution Architect",
      contact: "palepvar@amazon.com",
      photoUrl: Varsha,
    }
  ];
  
  function TeamMember({ name, role, contact, photoUrl }) {
    return (
      <Box padding="l" textAlign="center">
        <SpaceBetween size="m">
          <div style = {{textAlign: 'center', justifyContent: 'center', display: "flex"}}>
            <img src={photoUrl} alt={name} style={{ width: "280px", height: "500px", borderRadius: "50%" }} />
          </div>
          <Box variant="h2" textAlign="center">{name}</Box>
          <Box variant="awsui-key-label">{role}</Box>
          <Link href={`mailto:${contact}`}>{contact}</Link>
        </SpaceBetween>
      </Box>
    );
  }
  
  function MeetTheTeam() {
    return (
        <AppLayout
          navigation={<NavigationSide activeHref="/meettheteam"/>}
          content={<MainContent />}
          toolsHide={true}
          contentType="dashboard"
        />
    );
  }

  function MainContent() {
    return(
    <>
    <BreadcrumbGroup
            items={[
              { text: "Home", href: "/" },
              { text: "Meet the Team", href: "/meettheteams" },
            ]}
            ariaLabel="Breadcrumbs"
          />
    <ContentLayout
        defaultPadding
        // headerBackgroundStyle="linear-gradient(135deg, rgb(71, 17, 118) 3%, rgb(131, 57, 157) 44%, rgb(149, 85, 182) 69%, rgb(145, 134, 215) 94%)"
        headerVariant="high-contrast"
        maxContentWidth={2000}
        disableOverlap
        header={
          <SpaceBetween size="m">
            <Header variant="h1" description="AWS Solution Architects">Meet the Team</Header>
          </SpaceBetween>
        }
      >
                  <br></br>
        <div >
          <ColumnLayout columns={4} variant="text-grid">
            {teamMembers.map((member, index) => (
              <TeamMember key={index} {...member} />
            ))}
          </ColumnLayout>
        </div>
      </ContentLayout>
      </>
    );
  }

  function Navigation({ activeHref }) {
    return (
      <SideNavigation
        activeHref={activeHref}
        header={{ text: 'AWS Eloquence', href: '/' }}
        items={[
          { type: 'link', text: 'Learn More', href: '/learnmore' },
          { type: 'link', text: 'Get Started', href: '/getstarted' },
          { type: 'link', text: 'My Meetings', href: '/meetings'},
          { type: 'link', text: 'Meet the Team', href: '/meettheteam'},
          { type: 'link', text: 'Architecture Diagram', href: '/architecture'},
          { type: 'divider' },
          { type: 'link', text: 'Documentation', href: '/documentation' },
        ]}
      />
    );
  }

  
  export default MeetTheTeam;
